export const debug = true;
export const backendServer = 'https://care-free.app';
export const gameServer = 'https://care-free.app';
export const publicBuildUrl = `${backendServer}/wp-content/plugins/miro-cares-hoowy/build/`;

export const hoowy = [
    {
        item: 'Lichaam',
        title: 'Wat is kindermishandeling?',
        areas: [{
            borderRadius: 0,
            width: 300,
            height: 450,
            x: 100,
            y: 15,
        }],
    },
    {
        item: 'Buik',
        title: 'DE MELDCODE ALS HULPCODE',
        areas: [{
            borderRadius: 75,
            width: 162,
            height: 135,
            x: 170,
            y: 265,
        }],
    },
    {
        item: 'Ogen',
        title: 'HOE KAN JE SIGNALEN HERKENNEN?',
        areas: [{
            borderRadius: 50,
            width: 220,
            height: 105,
            x: 140,
            y: 92,
        }],
    },
    {
        item: 'Vleugels',
        title: 'HOE MAAK JE SAMEN HET VERSCHIL?',
        areas: [{
            borderRadius: 0,
            width: 60,
            height: 150,
            x: 100,
            y: 240,
        }, {
            borderRadius: 0,
            width: 60,
            height: 150,
            x: 340,
            y: 240,
        }],
    },
    {
        item: 'Snavel',
        title: 'HOE MAAK JE ZORGEN BESPREEKBAAR?',
        areas: [{
            borderRadius: 0,
            width: 50,
            height: 50,
            x: 226,
            y: 175,
        }],
    },
    {
        item: 'Pootjes',
        title: 'HOE KAN JE CARE-FREE INZETTEN?',
        areas: [{
            borderRadius: 0,
            width: 180,
            height: 72,
            x: 160,
            y: 390,
        }],
    }
];
